import useChallengesQuery from "@hooks/common/challenges/use-challenges-query";
import { BybButtonChip } from "@Components/common/byb-ds";
import { ChallengeCardSimple, ChallengeRowLarge, NavSection } from "@Components/game";
import { ChallengeFilterDialog } from "@Components/game/challenges";
import { HeaderButton } from "@Components/game/header/styled-components";
import ContainerWrapper from "@Components/generic/container-wrapper";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import { faSlidersSimple } from "@fortawesome/pro-solid-svg-icons";
import { useGlobalContext } from "@hooks/index";
import useI18n from "@i18n";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";

const PageId = "CATEGORY";

const Category = () => {
  const { globalState } = useGlobalContext();
  const { i18n } = useI18n();
  const { tag } = useParams<{ tag: string }>();
  const theme = useTheme();
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState<string[]>([]);

  const { challenges } = useChallengesQuery({
    exclude_tags: !globalState.user.isSuperAdmin ? ["QA", "DEVELOPMENT"] : [],
    unpublished_allowed: globalState.user.isSuperAdmin,
    order_by: [
      {
        field: "unlocked_at",
        direction: "asc",
      },
    ],
    ...(tag && tag !== "all" ? { include_tags: [tag!] } : {}),
  });

  useMount(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title: i18n(`tag.${tag}`) });
  });

  useEffect(() => {
    Events.app.setHeaderAltSections.emit({
      rightSection: (
        <HapticsButtonWrapper>
          <HeaderButton onClick={() => setFilterModalOpen(true)}>
            <Icon icon={faSlidersSimple} color={theme.palette.dsBase.v200} fontSize={24} />
          </HeaderButton>
        </HapticsButtonWrapper>
      ),
    });
    return () => {
      Events.app.setHeaderAltSections.emit(null);
    };
  }, []);

  const gridChallenges = challenges?.filter(challenge => {
    if (
      filters.length === 0 ||
      (filters.length > 0 && challenge.status && filters.includes(challenge.status)) ||
      (filters.includes("locked") && (challenge.unlocked_at || 0) > globalState.user.userRating!)
    ) {
      return challenge;
    }
  });
  return (
    <ContainerWrapper id={PageId} sx={{ overflow: "visible" }}>
      <Container maxWidth={false} disableGutters sx={{ padding: theme.spacing(0, 0, 6) }}>
        <ChallengeRowLarge
          padding={theme.spacing(6)}
          sx={{ padding: theme.spacing(3, 0) }}
          caption={i18n("challenges.category.page.latest.challenge")}
          limit={1}
          orderBy={[
            {
              field: "created_at",
              direction: "desc",
            },
          ]}
          tag={tag !== "all" ? tag : undefined}
        />

        <NavSection title={i18n("challenges.category.page.grid.title", { count: gridChallenges?.length || 0 })} sx={{ padding: theme.spacing(6) }}>
          {filters.length > 0 && (
            <Stack direction="row" spacing={2}>
              {filters.map(filter => (
                <BybButtonChip key={filter} onClick={() => setFilterModalOpen(true)}>
                  {i18n(`challenges.filter.${filter}`)}
                </BybButtonChip>
              ))}
            </Stack>
          )}

          <Stack>
            <Grid container spacing={3}>
              {gridChallenges.map(challenge => (
                <Grid item xs={3} key={challenge.id}>
                  <ChallengeCardSimple challenge={challenge} size="small" fullWidth />
                </Grid>
              ))}
            </Grid>
          </Stack>
        </NavSection>

        <ChallengeFilterDialog open={filterModalOpen} onClose={() => setFilterModalOpen(false)} onApply={filters => setFilters(filters)} />
      </Container>
    </ContainerWrapper>
  );
};

export default Category;
